import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { CacheItem, TransferHttpService } from '../../../services/transfer-http/transfer-http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AimsCommonConfirmDialogComponent, AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions } from '@aims/common-components';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import * as moment from 'moment-mini';

import {
  HrEmployees, HrEmployeeXOtherSpecialtyType, HrEmployeeXShareholderType, HrUnionAffiliation, HrDepartments,
  HrWorkSections, HrEmployeeJobAssignments, HrJobTitles, HrShareholderType, HrOtherSpecialtyType
} from '../../../../models';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';
import { DialogComponent } from 'src/app/services/message/message.enum';
import { MessageService } from 'src/app/services/message/message.service';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'employee',
  templateUrl: './employee.component.html',
  styleUrls: ['../hr.component.css'],
  providers: [TitleCasePipe, MainGridService]
})

export class EmployeeComponent implements OnInit {
  now: DateConstructor;

  otherSpecialtyTypeFormControl = new FormControl();
  allOhterSpecialtyTypesFiltered: Observable<HrOtherSpecialtyType[]>;
  @ViewChild('otherSpecialtyTypeInput') otherSpecialtyTypeInput: ElementRef<HTMLInputElement>;

  shareholderTypeFormControl = new FormControl();
  allShareholderTypesFiltered: Observable<HrShareholderType[]>;
  @ViewChild('shareholderTypeInput') shareholderTypeInput: ElementRef<HTMLInputElement>;


  occTablePermissions: AimsCommonTablePermissions = {
    filter: false,
    clear: false,
    create: false,
    update: false,
    delete: false,
  };

  occHeader: AimsCommonTableHeader[] = [
    { key: 'jobTitleId', label: 'Job Title', type: AimsCommonTableHeaderType.DYNAMIC },
    { key: 'occDate', label: 'Date', type: 'date', format: 'shortDate', width: 120 },
    { key: 'occStatusId', label: 'Status', type: AimsCommonTableHeaderType.DYNAMIC },
    { key: 'primaryOcc', label: 'Primary?', type: AimsCommonTableHeaderType.BOOLEAN},
    { key: 'employmentTypeId', label: 'Employment Type', type: AimsCommonTableHeaderType.DYNAMIC },
    { key: 'workSectionId', label: 'Work Section', type: AimsCommonTableHeaderType.DYNAMIC },
  ];

  pscTablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
  };

  pscsHeader: AimsCommonTableHeader[] = [
    { key: 'button', label: '', type: AimsCommonTableHeaderType.DYNAMIC, filter: false, width: 50 },
    { key: 'employeeStatusToId', label: 'Employee Status', type: AimsCommonTableHeaderType.DYNAMIC, filterType: AimsCommonTableFilterType.DYNAMIC },
    { key: 'pscTypeId', label: 'Type', type: AimsCommonTableHeaderType.DYNAMIC, filterType: AimsCommonTableFilterType.DYNAMIC },
    { key: 'effectiveOn', label: 'Effective', type: 'date', format: 'shortDate', width: 120 },
    { key: 'wsLeadReviewedOn', label: 'WS Lead', type: 'date', format: 'shortDate', width: 120, filter: false },
    { key: 'dmApprovedOn', label: 'DM', type: 'date', format: 'shortDate', width: 120, filter: false },
    { key: 'pmmApprovedOn', label: 'PMM', type: 'date', format: 'shortDate', width: 120, filter: false },
    { key: 'hrmApprovedOn', label: 'HRM', type: 'date', format: 'shortDate', width: 120, filter: false },
    { key: 'acctReceivedOn', label: 'ACCT', type: 'date', format: 'shortDate', width: 120, filter: false },
    { key: 'itReceivedOn', label: 'IT', type: 'date', format: 'shortDate', width: 120, filter: false },
    { key: 'createdBy', label: 'Created By', type: AimsCommonTableHeaderType.STRING, filter: false },
    { key: 'createdOn', label: 'Created On', type: 'date', format: 'shortDate', width: 120, filter: false },
    { key: 'hrAuditedBy', label: 'Audited By', type: AimsCommonTableHeaderType.STRING, filter: false },
    { key: 'hrAuditedOn', label: 'Audited On', type: 'date', format: 'shortDate', width: 120, filter: false },
  ];

  constructor(private transferHttp: TransferHttpService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private messageService: MessageService,
    private titlecasePipe: TitleCasePipe,
    public permissions: PermissionsService) {

  }

  tenantConfig = this.transferHttp.tenantConfig;
  tenantUsesPsc = this.tenantConfig.hr.tenantUsesPsc;
  tenantRequiresPersonalInfo = this.tenantConfig.hr.tenantRequiresPersonalInfo;
  empConfig = this.tenantConfig.hr.empConfig;

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = true;

  //Header
  headerText = "Employee";
  routedFrom = "employee";

  //Form Control
  editable: boolean = false;
  isPermittedUpdater: boolean = false;

  isProbationRequired: boolean = true;
  newEmp: boolean = false;
  empValid: boolean = false;
  empSaved: boolean = false;
  empValidStatus: string = "Valid!"

  displayCurInfo: boolean = true;
  displayPerInfo: boolean = true;
  displayOccInfo: boolean = this.tenantUsesPsc;
  displayPscInfo: boolean = this.tenantUsesPsc;
  displayStatus: boolean = false;

  isSameAddress: boolean = false;
  isSsnValid: boolean = true;
  isEmpNoValid: boolean = true;


  //Calculated values
  yearsOfServiceValue: string;


  //DropDown or config Values
  departmentValues = this.transferHttp.getSingle(`Common/GetAllDepartmentsForDropdown`);
  workSectionValues = this.transferHttp.getSingle(`Common/GetAllWorkSectionsForDropdown`);
  employeeJobAssignmentValues = this.transferHttp.getSingle(`Common/GetAllEmployeeJobAssignmentsForDropdown`)
  jobTitleValues = this.transferHttp.getSingle(`Common/GetAllJobTitlesForDropdown`);
  stateOrTerritoryValues = this.transferHttp.getSingle(`Common/GetAllStatesOrTerritories`);
  siteValues = this.transferHttp.getCache(CacheItem.sites);

  clearanceStatusValues = this.transferHttp.getSingle(`hr/GetClearanceStatusForDropdown`);
  eeoTypeValues = this.transferHttp.getSingle('hr/GetEeoType');
  activeEeoTypeValues = this.transferHttp.getSingle('hr/GetActiveEeoType');
  employeeStatusValues = this.transferHttp.getSingle(`hr/GetEmployeeStatusForDropDown`);
  employmentStatusValues = this.transferHttp.getSingle(`hr/GetEmploymentStatus`);
  employmentTypeValues = this.transferHttp.getSingle(`hr/GetEmploymentType`);
  genderTypeValues = this.transferHttp.getSingle(`hr/GetGenderType`);
  maritalStatusValues = this.transferHttp.getSingle(`hr/GetMaritalStatus`);
  occStatusValues = this.transferHttp.getSingle(`hr/GetOccStatus`);
  pscTypeValues = this.transferHttp.getSingle(`hr/GetPscTypeForDropDown`);
  unionValues = this.transferHttp.getSingle(`hr/GetUnionAffiliation`);
  unionAffiliationValues = this.transferHttp.getSingle(`hr/GetUnionAffiliation`);
  shareholderTypeValues: Observable<HrShareholderType[]> = this.transferHttp.getSingle(`hr/GetShareholderType`);
  otherSpecialtyTypeValues: Observable<HrOtherSpecialtyType[]> = this.transferHttp.getSingle('hr/GetOtherSpecialtyType')


  //Used for aims-lookup
  stateLookupColumns:AimsCommonTableHeader[] = [
    { key: 'stateOrTerritory', label: 'State', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'postalCode', label: 'State Code', type: AimsCommonTableHeaderType.STRING, filter: true }
  ];

  employeeJobAssignmentLookupColumns:AimsCommonTableHeader[]  = [
    { key: 'assignmentDescription', label: 'Assignment', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN, filter: true },
    { key: 'jobTitle', label: 'Job Title', type: AimsCommonTableHeaderType.STRING, filter: true }
  ];

  validationData = [];

  // Arrays to cascade dropdowns
  allUnionAffiliations: HrUnionAffiliation[] = [];
  filteredUnionAffiliations: HrUnionAffiliation[] = [];

  allDepartments: HrDepartments[] = [];
  filteredDepartments: HrDepartments[] = [];

  allWorkSections: HrWorkSections[] = [];
  filteredWorkSections: HrWorkSections[] = [];

  allJobTitles: HrJobTitles[] = [];
  filteredJobTitles: HrJobTitles[] = [];

  allJobAssignments: HrEmployeeJobAssignments[] = [];
  filteredJobAssignments: HrEmployeeJobAssignments[] = [];

  // Arrays for MatChipLists
  allShareholderTypes: HrShareholderType[] = [];
  allOtherSpecialtyTypes: HrOtherSpecialtyType[] = [];

  //Field Values
  emp: HrEmployees = new HrEmployees();

  today = new Date();
  separatorKeysCodes: number[] = [ENTER, COMMA];

  //Get reference to ngForm
  @ViewChild('empForm', { static: true }) empForm; FormGroup

  //***************************
  // Functions
  //***************************

  public updateEmpValidStatus() {

    this.displayStatus = true;

    if (this.empForm.dirty && this.empForm.valid) {
      this.empValid = true;
      this.empSaved = false;
      this.empValidStatus = "Valid!"
    }
    else if (this.empForm.pristine) {
      this.empValid = true;
      this.empSaved = false;
    }
    else if (this.empForm.valid) {
      this.empValid = true;
    }
    else if (!this.empForm.valid) {
      this.empValidStatus = "Enter all required data!";
      this.empValid = false;
    }

    if (this.emp.driversLicenseExpDate <= this.today) {
      this.empValid = false;
      this.empValidStatus = "Update drivers license!";
    }

  }

  // Cascading dropdown WorkSection changes when Dept changes -- need both Id and value of dept to update employee record
  public filterDepartments() {
    this.filteredDepartments = this.allDepartments.filter(d => d.active);
  }

  public filterWorkSection() {
    this.filteredWorkSections = this.allWorkSections.filter(w => w.departmentId == this.emp.departmentId && w.active);
  }

  // Cascading dropdown Job Tile changes when WS changes -- need both the Id and value of WS to updated employee record
  public filterJobTitle() {
    this.filteredJobTitles = this.allJobTitles.filter(jt => jt.unionAffiliationId == this.emp.unionAffiliationId && jt.workSectionId == this.emp.workSectionId && jt.active);
  }

  // Cascading dropdown Assignment changes when Job Title changes -- need both the Id and value of Job Assignment to updated employee record
  public filterJobAssignment() {
    this.filteredJobAssignments = this.allJobAssignments.filter(ja => ja.jobTitleId == this.emp.titleId && ja.active);
  }

  public defaultUnion(value): void {
    if (value) {
      this.emp.unionAffiliationId = this.empConfig.defaultUnionId;
    }
    else {
      this.emp.unionAffiliationId = null;
    }
  }

  //validate/update fistName, lastName, loginName, and SSN
  //ignore employeeNumber 000000
  validateUserInput(event: any): void {

    this.displayStatus = true;

    if (event.currentTarget.id == "employeeNumber" && this.emp.employeeNumber != "000000") {
      let checkEmployeeNumber = this.validationData.filter(e => e.employeeNumber == this.emp.employeeNumber);
      if (checkEmployeeNumber.length > 0) {
        alert("Employee Number: " + this.emp.employeeNumber + " already exists in the HR database, please check and re-enter!");
        this.isEmpNoValid = false;
        this.emp.employeeNumber = "0";
      }
      else {
        this.isEmpNoValid = true;
      }
    }
    else if (event.currentTarget.id == "firstName") {
      let loginName1: string;
      let loginName2: string;

      // loginName
      let loginName = (this.emp.firstName.replace(/([^a-z0-9]+)/gi, "") + "." + this.emp.lastName.replace(/([^a-z0-9]+)/gi, "")).toLowerCase();

      let checkLoginName = this.validationData.filter(e => {
        loginName1 = (e.firstName.replace(/([^a-z0-9]+)/gi, "") + "." + e.lastName.replace(/([^a-z0-9]+)/gi, "")).toLowerCase();
        loginName2 = e.loginName;

        if (loginName2 != null) {
          loginName2 = loginName2.toLowerCase();
        }

        if (loginName1 == loginName) {
          return (loginName1 == loginName);
        }
        else if (loginName2 != null && (loginName2 == loginName)) {
          return (loginName2 == loginName);
        }
        else {
          return 0
        }
      });

      if (checkLoginName.length == 0) {
        this.emp.loginName = loginName;
      }
      else {
        alert("Login Name: " + loginName + " already exists!");
        this.emp.loginName = loginName + checkLoginName.length.toString();
      }
    }

    else if (event.currentTarget.id == "ssn") {

      let checkSnn = this.validationData.filter(e => {
        if (e.ssn != null) {
          e.ssn == this.emp.ssn
          return e.ssn == this.emp.ssn;
        }
        else {
          return 0
        }
      });

      if (checkSnn.length != 0) {
        alert("SSN: " + this.emp.ssn + " already exists in the HR database, please check and re-enter!");
        this.isSsnValid = false;
        this.emp.ssn = null;
      }

      else {
        this.isSsnValid = true;
      }

    }
    else if (event.currentTarget.id == 'middleName') {
      if ((this.emp.middleName == null || this.emp.middleName == '' || this.emp.middleName == '(nmn)' || this.emp.middleName == '(NMN)')) {
        this.emp.middleName = '(NMN)';
        this.emp.mi = null;
      }
      else {
        this.emp.mi = this.titlecasePipe.transform(event.currentTarget.value.charAt(0));
      }
    }
    else if (event.currentTarget.id == 'aka') {
      this.emp.aka = this.titlecasePipe.transform(event.currentTarget.value);
    }
    else {
      return;
    }
  }


  public calculateEditable() {
    let returnVal = false;

    if (this.permissions.canUpdate(this.permissions.ComponentID.Employee) && (this.newEmp || !this.tenantUsesPsc)) {
      returnVal = true;
    }
    return returnVal;
  }

  //Shareholder fuctions
  public shareholderUnchecked() {
    let retArr: HrEmployeeXShareholderType[] = [];
    if (!this.emp.shareholder) {
      this.emp.hrEmployeeXShareholderType = retArr;
    }
  }

  async getShareholderTypesPromise() {
    return await this.allShareholderTypesFiltered
      .pipe(take(1))
      .toPromise();
  }

  public async addEmpXShare(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    // Add our fruit
    if ((value || '').trim()) {
      this.getShareholderTypesPromise().then(async data => {
        // This allows the user to type part of it, see it in auto-complete trimmed and then hit enter
        // without manually selecting with the mouse
        const shareType = data.find(i => i.shareholderType.toLowerCase().indexOf(value.toLowerCase()) > -1)
        if (shareType) {
          const empxShareResults = await this.empxShare.toPromise()
          const selectedValue = empxShareResults.find(d => d.shareholderTypeId === shareType.shareholderTypeId);
          this.emp.hrEmployeeXShareholderType.push(selectedValue);
        }
      })
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.shareholderTypeFormControl.setValue(null);
  }

  removeEmpXShare(shareholderType: HrEmployeeXShareholderType): void {
    const index = this.emp.hrEmployeeXShareholderType.indexOf(shareholderType);
    if (index >= 0) {
      this.emp.hrEmployeeXShareholderType.splice(index, 1);
    }
  }

  async selectedEmpXShare(event: MatAutocompleteSelectedEvent) {
    const empxShareResults = await this.empxShare.toPromise()
    const selectedValue = empxShareResults.find(d => d.shareholderTypeId === event.option.value);
    this.emp.hrEmployeeXShareholderType.push(selectedValue);
    this.shareholderTypeInput.nativeElement.value = '';
    this.shareholderTypeFormControl.setValue(null);
  }

  private async autoCompleteListShareholderType() {
    const data: HrShareholderType[] = await this.shareholderTypeValues.toPromise();
    this.allShareholderTypesFiltered = this.shareholderTypeFormControl.valueChanges.pipe(
      startWith(null),
      map((shareholderTypeStr: string | null) => shareholderTypeStr ? this._filterSH(data, shareholderTypeStr) : this.filterBasedOnAlreadyPresentValuesSH(data)));
  }

  private filterBasedOnAlreadyPresentValuesSH(data) {
    return data.filter(d => {
      return this.emp.hrEmployeeXShareholderType.findIndex(f => f.shareholderTypeId === d.shareholderTypeId) === -1
    });
  }

  private _filterSH(data, value: string): HrShareholderType[] {
    if (!value.toLowerCase) {
      return this.filterBasedOnAlreadyPresentValuesSH(data)
    }
    return this.filterBasedOnAlreadyPresentValuesSH(data).filter(i => i.shareholderType.toLowerCase().indexOf(value.toLowerCase()) > -1)
  }

  //OtherSpecalites fuctions
  public otherSpecialtyUnchecked() {
    let retArr: HrEmployeeXOtherSpecialtyType[] = [];
    if (!this.emp.otherSpecialties) {
      this.emp.hrEmployeeXOtherSpecialtyType = retArr;
    }
  }

  async getOtherSpecialtyTypesPromise() {
    return await this.allOhterSpecialtyTypesFiltered
      .pipe(take(1))
      .toPromise();
  }

  public async addEmpXOtherSpecialty(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.getOtherSpecialtyTypesPromise().then(async data => {
        // This allows the user to type part of it, see it in auto-complete trimmed and then hit enter
        // without manually selecting with the mouse
        const otherSpecialtyType = data.find(i => i.otherSpecialtyType.toLowerCase().indexOf(value.toLowerCase()) > -1)
        if (otherSpecialtyType) {
          const empxOtherSpecialtyResults = await this.empxOtherSpecialty.toPromise()
          const selectedValue = empxOtherSpecialtyResults.find(d => d.otherSpecialtyTypeId === otherSpecialtyType.otherSpecialtyTypeId);
          this.emp.hrEmployeeXOtherSpecialtyType.push(selectedValue);
        }
      })
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.otherSpecialtyTypeFormControl.setValue(null);
  }

  removeEmpXOtherSpecialty(otherSpecialtyType: HrEmployeeXOtherSpecialtyType): void {
    const index = this.emp.hrEmployeeXOtherSpecialtyType.indexOf(otherSpecialtyType);

    if (index >= 0) {
      this.emp.hrEmployeeXOtherSpecialtyType.splice(index, 1);
    }
  }

  async selectedEmpXOtherSpecialty(event: MatAutocompleteSelectedEvent) {
    const empxOtherSpecialtyResults = await this.empxOtherSpecialty.toPromise()
    const selectedValue = empxOtherSpecialtyResults.find(d => d.otherSpecialtyTypeId === event.option.value);
    this.emp.hrEmployeeXOtherSpecialtyType.push(selectedValue);
    this.otherSpecialtyTypeInput.nativeElement.value = '';
    this.otherSpecialtyTypeFormControl.setValue(null);
  }

  private async autoCompleteListOtherSpecialtyType() {
    const data: HrOtherSpecialtyType[] = await this.otherSpecialtyTypeValues.toPromise();
    this.allOhterSpecialtyTypesFiltered = this.otherSpecialtyTypeFormControl.valueChanges.pipe(
      startWith(null),
      map((otherSpecialtyTypeStr: string | null) => otherSpecialtyTypeStr ? this._filterOS(data, otherSpecialtyTypeStr) : this.filterBasedOnAlreadyPresentValuesOS(data)));
  }

  private filterBasedOnAlreadyPresentValuesOS(data) {
    return data.filter(d => {
      return this.emp.hrEmployeeXShareholderType.findIndex(f => f.shareholderTypeId === d.shareholderTypeId) === -1
    });
  }

  private _filterOS(data, value: string): HrOtherSpecialtyType[] {
    if (!value.toLowerCase) {
      return this.filterBasedOnAlreadyPresentValuesOS(data)
    }
    return this.filterBasedOnAlreadyPresentValuesOS(data).filter(i => i.otherSpecialtyType.toLowerCase().indexOf(value.toLowerCase()) > -1)
  }

  public loadEmp(empId: number) {
    //Load Emp
    this.transferHttp.get('Hr/GetEmployeeDetail?empId=' + empId).subscribe(emp => {

      //Set emp fields
      this.emp = emp;
      // only show PSC hat have been accepted when viewing the employee record
      this.emp.hrPscEmployee = this.emp.hrPscEmployee.filter(p => p.accepted == true);

      this.headerText = "Employee Details - " + this.emp.fullName;

      this.calculatedYearsOfService();
      this.calculateEditable();
      this.checkForSameAddress();

      this.showSpinner = false;

    },
      error => { console.log(error); });
  }

  public calculatedYearsOfService() {
    // Terminated - Laid off - Retired?
    let end = moment();

    if (this.emp.termDateLayoffDate) {
      end = moment(this.emp.termDateLayoffDate);
    }

    // Bridge Date ?
    let start = moment(this.emp.originalDateofHire);

    if (this.emp.bridgedDateofHire) {
      start = moment(this.emp.bridgedDateofHire)
    }

    let years = end.diff(start, 'year');
    start.add(years, 'years');

    let months = end.diff(start, 'months');
    start.add(months, 'months');

    let days = end.diff(start, 'days');

    //build the yearsOfSeriveValue string
    if (years < 1) {
      this.yearsOfServiceValue = "0" + ' years ';
    }
    else if (years == 1) {
      this.yearsOfServiceValue = years + ' year ';
    }
    else if (years > 1) {
      this.yearsOfServiceValue = years + ' years ';
    }

    if (months < 1) {
      this.yearsOfServiceValue = this.yearsOfServiceValue + "0" + ' months ';
    }
    else if (months == 1) {
      this.yearsOfServiceValue = this.yearsOfServiceValue + months + ' month ';
    }
    else if (months > 1) {
      this.yearsOfServiceValue = this.yearsOfServiceValue + months + ' months ';
    }

    if (days < 1) {
      this.yearsOfServiceValue = this.yearsOfServiceValue + "0" + ' days ';
    }
    else if (days == 1) {
      this.yearsOfServiceValue = this.yearsOfServiceValue + days + ' day ';
    }
    else if (days > 1) {
      this.yearsOfServiceValue = this.yearsOfServiceValue + days + ' days ';
    }
  }

  public checkForSameAddress() {

    if (this.emp.homeAddress != null && this.emp.homeAddress == this.emp.mailingAddress) {
      this.isSameAddress = true;
    }
    else {
      this.isSameAddress = false;
    }
  }


  public handleHomeStreetChanged() {
    if (this.isSameAddress) {
      this.emp.mailingAddress = this.emp.homeAddress;
    }
  }

  public handleHomeCityChanged() {
    if (this.isSameAddress) {
      this.emp.mailingCity = this.emp.homeCity;
    }
  }

  public handleHomeStateChanged(homeStateId) {
    if (this.isSameAddress && this.emp.homeAddress != null) {
      this.emp.mailingStateId = homeStateId;
    }
  }

  public handleHomeZipChanged() {
    if (this.isSameAddress) {
      this.emp.mailingZip = this.emp.homeZip;
    }
  }


  public handleSameAddressChecked() {
    if (this.isSameAddress) {
      if (this.emp.homeAddress != null) {
        this.emp.mailingAddress = this.emp.homeAddress;
      }
      if (this.emp.homeCity != null) {
        this.emp.mailingCity = this.emp.homeCity;
      }
      if (this.emp.homeStateId != null) {
        this.emp.mailingStateId = this.emp.homeStateId;
      }
      if (this.emp.homeZip != null) {
        this.emp.mailingZip = this.emp.homeZip;
      }
    }
    else if (!this.isSameAddress) {
      this.emp.mailingAddress = null;
      this.emp.mailingCity = null;
      this.emp.mailingStateId = null;
      this.emp.mailingZip = null;
    }
  }


  public setDefaults() {
    //Set defaults
    this.showSpinner = false;
    this.calculateEditable();
    this.headerText = "Create Employee";
    this.newEmp = true;
    this.empValidStatus = "New Employee"
    this.emp.exempt = false;
    this.emp.employmentTypeId = null;
    this.emp.employmentStatusId = null;
    this.emp.unionAffiliationId = null;
    this.emp.departmentId = null;
    this.emp.workSectionId = null;
    this.emp.titleId = null;
    this.emp.employeeJobAssignmentId = null;
    this.emp.genderTypeId = null;
    this.emp.eeoId = null;
    this.emp.maritalStatusId = null;
    this.emp.eligibleForRehire = true;
    this.emp.employeeStatusId = this.empConfig.defaultEmployeeStatusId;
    this.emp.permanentSiteId = this.empConfig.defaultPermSiteId;
    this.emp.clearanceStatusId = this.empConfig.defaultClearanceStatusId;
    this.emp.clearanceDate = this.today;
    this.emp.homeStateId = this.empConfig.defaultHomeStateId || null;
    this.displayOccInfo = false;
    this.displayPscInfo = false;
    this.isSameAddress = false;
  }

  openPsc(pscId: number, empId: number) {
    this.router.navigate([`/hr/psc/${pscId}/${this.routedFrom}`]);
  }


  //Cancel
  public cancelEmp() {

    var message = this.messageService.getDialogMessage(DialogComponent.UnsavedChanges);
    let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent,{
      data: message
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult){
        this.router.navigate([`/hr/viewEmployees`]);
      }
      dialogRef = null;
    });
  }

  //Save Emp
  public saveEmp(emp: HrEmployees) {

    this.displayCurInfo = true;
    this.displayPerInfo = true;

    this.showSpinner = true;

    if (!this.newEmp) {

      this.spinnerText = "Saving Employee...";
      this.transferHttp.put('hr/SaveEmployee', emp).subscribe(retVal => {
        this.empValidStatus = "Saved"
        this.empSaved = true;
        this.loadEmp(emp.employeeId);
        this.showSpinner = false;
      });
    }
    else {
      this.spinnerText = "Creating Employee and New Hire PSC...";
      this.transferHttp.post(`hr/CreateEmployee?createPsc=${this.tenantUsesPsc}`, emp).subscribe(retVal => {
        this.newEmp = false;
        this.empValidStatus = "Created"
        this.empSaved = true;
        this.router.navigate(['/hr/employee/' + retVal]);
        this.showSpinner = false;
      });
    }
  }

  empxOtherSpecialty: Observable<HrEmployeeXOtherSpecialtyType[]> = this.transferHttp.getSingle(`hr/GetEmployeeXOtherSpecialtyValues?empId=${this.emp.employeeId}`);
  empxShare: Observable<HrEmployeeXShareholderType[]> = this.transferHttp.getSingle(`hr/GetEmployeeXShareholderValues?empId=${this.emp.employeeId}`);

  ngOnInit(): void {

    //If id provided, load existing emp data
    this.route.params.subscribe(e => {
      this.unionAffiliationValues.subscribe(data => { this.allUnionAffiliations = data; this.filteredUnionAffiliations = data });

      this.departmentValues.subscribe(data => { this.allDepartments = data; this.filteredDepartments = data })

      this.workSectionValues.subscribe(data => { this.allWorkSections = data; this.filteredWorkSections = data });

      this.jobTitleValues.subscribe(data => { this.allJobTitles = data; this.filteredJobTitles = data; });

      this.employeeJobAssignmentValues.subscribe(data => { this.allJobAssignments = data; this.filteredJobAssignments = data });

      this.shareholderTypeValues.subscribe(data => {
        this.allShareholderTypes = data.filter(d => {
          return this.emp.hrEmployeeXShareholderType.findIndex(f => f.shareholderTypeId === d.shareholderTypeId) > -1
        });
        this.autoCompleteListShareholderType();
      })

      this.otherSpecialtyTypeValues.subscribe(data => {
        this.allOtherSpecialtyTypes = data.filter(d => {
          return this.emp.hrEmployeeXOtherSpecialtyType.findIndex(f => f.otherSpecialtyTypeId === d.otherSpecialtyTypeId) > -1
        });
        this.autoCompleteListOtherSpecialtyType();
      })

      this.showSpinner = true;


      // load in validationData
      this.transferHttp.getSingle(`hr/GetEmployeeValidationData?empId=${e["empId"]}`)
        .subscribe(data => {
          this.validationData = data;
          this.showSpinner = false;
        });

      if (e['empId']) {
        this.loadEmp(e['empId']);
      }
      else {
        this.setDefaults();
      }

    });

  }
}
